export default "__VITE_ASSET__DkZq9VDA__"